import './style/base.less'
import Alert from './src/alert'
import Confirm from './src/confirm'
import Toast from './src/toast'
import Notify from './src/notify'
import Loading from './src/loading'

// export {
//     Confirm,
//     Alert,
//     Toast,
//     Notify,
//     Loading
// };

/* istanbul ignore next */
Alert.install = function install(Vue) {
  Vue.component(Alert.name, Alert)
}
Confirm.install = function install(Vue) {
  Vue.component(Confirm.name, Confirm)
}
Toast.install = function install(Vue) {
  Vue.component(Toast.name, Toast)
}
Notify.install = function install(Vue) {
  Vue.component(Notify.name, Notify)
}
Loading.install = function install(Vue) {
  Vue.component(Loading.name, Loading)
}

export { Alert, Confirm, Toast, Notify, Loading }
